/**
 * PostHog Feature Flag Keys
 * Central place for all PostHog feature flag constants
 *
 * Usage:
 *   import { FeatureFlagKeys } from '../constants/ff.posthog';
 *   const isEnabled = useFeatureFlag(FeatureFlagKeys.addDailyPayOption);
 */

export const FeatureFlagKeys = {
  addDailyPayOption: 'ARF-1866-add-daily-pay-option',
  credentialingV2: 'TEMP-13770-credentialing-v2',
  enablePermanentJobV2AdminPanel: 'ARF-30-enable-permanent-job-v2-admin-panel',
  bestInDentalAdminPanel: 'GOTU-5623-best-in-dental-admin-panel',
  blockAddChildToOfficeWithCompletedShifts:
    'GOTU-4592-block-add-child-to-office-with-completed-shifts',
  dsoManagersFromAuthService: 'GOTU-6387-dso-managers-from-auth-service',
  gotuAdminsAdminPanel: 'GOTU-5861-gotu-admins-admin-panel',
  // Read the office-profile slice of a DNT profile from org-service (via the
  // admin-authed monolith /admin/office route) instead of /admin/users/:id.
  // `admin-portlal` is the deliberate spelling — it matches the GOTU-5263
  // ticket's PostHog key and this repo's own name verbatim. The key must equal
  // the PostHog flag exactly, so do NOT "correct" it to `admin-portal`, or
  // `isFeatureEnabled` returns false forever and the read path never runs.
  officeSliceRead: 'GOTU-5263-admin-portlal-office-read',
  // `transparancy` is misspelled in PostHog. The key has to match the flag
  // verbatim, so the typo stays until the flag itself is renamed.
  officeReviewsRatingTransparency:
    'GOTU-6266-enforce-office-reviews-rating-transparancy-and-tag-based-feedback',
  recruitersFromAuthService: 'GOTU-6388-recruiters-from-auth-service',
  // Shared referral-rebuild flag (also gates the mobile Refer & Earn screen).
  // Off: the admin Referral List reads the monolith `admin/referral`
  // endpoint. On: it reads referral-service's admin read endpoint instead.
  // Temporary — remove the admin-portal usage after the prod rollout.
  referralProgramRebuild: 'GOTU-6523-referral-program-rebuild',
};
